// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__hcDRO","header":"MergedInvoice_header__3fTUA"};